import { render, staticRenderFns } from "./OrderAnalisys.vue?vue&type=template&id=10667c1c&scoped=true&"
import script from "./OrderAnalisys.vue?vue&type=script&lang=ts&"
export * from "./OrderAnalisys.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAnalisys.vue?vue&type=style&index=0&id=10667c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10667c1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VProgressCircular,VRow,VSelect,VSheet,VTextField,VTextarea})
